// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3DS79","group":"styles_group__3VwWn"};